import { Box, Button, Grid, Paper, Skeleton, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { toFormData } from "axios";
import FileDropZone from "components/FileDropZone";
import SimpleBarScroll from "components/SimpleBar";
import server_api from "data/server_apis/server_api";
import ProductVideoUploadStatus from "pages/products/ProductVideoUploadStatus";
import React from "react";
import { useState } from "react";
import ReactPlayer from "react-player/lazy";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProductVideoThunk,
  getProductThunk,
  productSelector,
} from "store/reducers/product/productSlice";

const ProductVideos = ({ fullGrid = false, product_id, completed = null }) => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const product = useSelector((state) =>
    productSelector.selectById(state, product_id)
  );

  const [fileStatus, setFileStatus] = useState([]);
  const [submitting, setSubMitting] = useState(false);

  const removeVideo = (video) => {
    dispatch(deleteProductVideoThunk({ id: video, product: product }));
  };
  const { loading } = useSelector((state) => state.product.videoStatus);

  const uploadVideos = () => {
    setSubMitting(true);
    const _fileStatus = files.map((file) => ({
      progress: 0,
      status: "pending",
    }));
    setFileStatus(_fileStatus);
    files.forEach((file, index) => {
      (async () => {
        const item = _fileStatus[index];
        const data = { product: product.id, video: file };
        try {
          const resp = await server_api.postForm(
            "/commodity/product-video",
            toFormData(data),
            {
              onUploadProgress: (progressEvent) => {
                const percentComplete = parseInt(
                  (progressEvent.loaded / progressEvent.total) * 100
                );
                item.progress = percentComplete;
                setFileStatus([..._fileStatus]);
              },
            }
          );

          item.status = "success";
          setFileStatus([..._fileStatus]);
        } catch (err) {
          item.status = "failed";
          setFileStatus([..._fileStatus]);
        }
      })();
    });

    if (completed) {
      completed();
    }
    dispatch(getProductThunk(product.id));
  };
  return (
    <Box padding={2} sx={{ overflow: "hidden" }}>
      <SimpleBarScroll sx={{ height: "100%" }}>
        {product?.videos.length > 0 && (
          <>
            <Typography variant="h5" color="text.secondary">
              Videos in this machine
            </Typography>

            <Grid container spacing={1}>
              {product?.videos.map((item) => (
                <Grid item key={item.id} lg={2} md={3} sm={6}>
                  <Paper>
                    {loading?.delete === item.id ? (
                      <Skeleton
                        variant="rectangular"
                        sx={{ height: 200, width: "100%" }}
                        animation="wave"
                      />
                    ) : (
                      <ReactPlayer
                        width="100%"
                        height={200}
                        url={item.video}
                        controls={true}
                        light={false}
                      />
                    )}

                    <Stack justifyContent="center">
                      <Button
                        color="error"
                        onClick={() => removeVideo(item.id)}
                      >
                        Delete
                      </Button>
                    </Stack>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </>
        )}

        {!submitting && (
          <>
            <Typography variant="h5" color="text.secondary" marginTop={2}>
              Upload {product?.videos.length > 0 && "more"} videos (AVI,MP4,MKV)
            </Typography>
            <Grid container>
              <Grid item lg={fullGrid ? 12 : 6} sm={12}>
                <Box>
                  <FileDropZone
                    maxFiles={5}
                    accept={{
                      "video/mp4": [".mp4"],
                      "video/avi": [".avi"],
                      "video/x-matroska": [".mkv"],
                    }}
                    mode="video"
                    files={files}
                    setFiles={setFiles}
                  />

                  {files.length > 0 && (
                    <Box display="flex" padding={1} justifyContent="center">
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={uploadVideos}
                        // onClick={() => setSubMitting(true)}
                      >
                        Upload videos
                      </Button>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
          </>
        )}

        <Grid container>
          <Grid item lg={6} sm={12}>
            <Box
              padding={1}
              visibility={submitting ? "visible" : "hidden"}
              {...(!submitting && { display: "none" })}
            >
              <Typography color="text.secondary" variant="h5" marginBottom={1}>
                Uploading in progress
              </Typography>
              {files.map((item, index) => (
                <ProductVideoUploadStatus
                  file={item}
                  key={index}
                  progress={fileStatus[index]?.progress}
                  status={fileStatus[index]?.status}
                />
              ))}
            </Box>
          </Grid>
        </Grid>
      </SimpleBarScroll>
    </Box>
  );
};

export default ProductVideos;
